//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PermissionsMixin from "@Broker/@Modules/settings/mixins/permissions-mixin";
import { showToast } from "@Shared/@Utils/constants";
import { computed, defineComponent, onMounted, ref, toRefs, watch } from "@vue/composition-api";
import useVuelidate from "@vuelidate/core";
import { cloneDeep, isEqual } from "lodash";
import { useI18n } from "vue-i18n-composable";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { createNamespacedHelpers } from "vuex-composition-helpers";
import BoardsTabLoader from "./boards-tab-loader";
import ListComponent from "./list";
const {
  useActions,
  useState
} = createNamespacedHelpers("SettingsStore");
export default defineComponent({
  name: "BoardsTab",
  components: {
    ListComponent,
    BoardsTabLoader
  },
  mixins: [PermissionsMixin, validationMixin],
  props: {
    saving: {
      type: Boolean,
      required: true
    }
  },
  setup(props, {
    emit
  }) {
    // -------------- Constants ---------------

    const {
      tc
    } = useI18n();
    const LOCALE = {
      en: "en",
      fr: "fr"
    };

    // ---------------- Values ----------------

    const {
      saving
    } = toRefs(props);
    const loading = ref(false);
    const initialBrokerageBoards = ref({});
    const localBrokerageBoards = ref({
      displayFrench: false,
      statuses: {
        [LOCALE.en]: [],
        [LOCALE.fr]: []
      }
    });

    // --------------- Validation ---------------

    const rules = computed(() => ({
      statuses: {
        required
      },
      displayFrench: {
        required
      }
    }));
    const $v = useVuelidate(rules, localBrokerageBoards);

    // --------------- Computed ---------------

    const isValid = computed(() => !$v.value.$invalid);
    const isDirty = computed(() => !isEqual(initialBrokerageBoards.value, localBrokerageBoards.value));
    const allowSave = computed(() => isValid.value && isDirty.value);
    const displayLocale = computed(() => localBrokerageBoards.value.displayFrench ? LOCALE.fr : LOCALE.en);
    const languageOptions = computed(() => [{
      text: tc("settings.boardsTab.languageLabel.en"),
      value: false
    }, {
      text: tc("settings.boardsTab.languageLabel.fr"),
      value: true
    }]);

    // --------------- Methods ---------------

    const {
      LOAD_BROKERAGE_BOARDS,
      UPDATE_BROKERAGE_BOARDS
    } = useActions(["LOAD_BROKERAGE_BOARDS", "UPDATE_BROKERAGE_BOARDS"]);
    const updateStatuses = statuses => {
      localBrokerageBoards.value.statuses[displayLocale.value] = statuses;
    };
    const saveBrokerageBoards = async () => {
      try {
        if (!isValid.value) return;
        await UPDATE_BROKERAGE_BOARDS(localBrokerageBoards.value);
        emit("finish-saving", true);
        initialBrokerageBoards.value = cloneDeep(localBrokerageBoards.value);
        $v.value.$reset();
        showToast("success", "informationUpdatedSuccessfully");
      } catch (e) {
        emit("finish-saving", false);
      }
    };
    const {
      brokerageBoards
    } = useState(["brokerageBoards"]);

    // --------------- Watchers ---------------

    watch(allowSave, value => {
      emit("allow-save", value);
    });
    watch(saving, value => {
      if (value) saveBrokerageBoards();
    });

    // --------------- onMounted ---------------

    onMounted(async () => {
      loading.value = true;
      await LOAD_BROKERAGE_BOARDS();
      localBrokerageBoards.value = cloneDeep(brokerageBoards.value);
      initialBrokerageBoards.value = cloneDeep(localBrokerageBoards.value);
      $v.value.$reset();
      loading.value = false;
    });

    // --------------- Returns ---------------

    return {
      loading,
      localBrokerageBoards,
      updateStatuses,
      displayLocale,
      languageOptions
    };
  }
});